import { SettingsState, getDefaultSettings, mergeSettings } from "./settings-state"

export const loadSettings = (): SettingsState | null => {
  const savedSettings = localStorage.getItem("settings")
	const settings = savedSettings 
		? mergeSettings(getDefaultSettings(), JSON.parse(savedSettings))
		: getDefaultSettings()
	
	return settings
}

export const saveSettings = (settings: SettingsState) => {
  // const memento = new SettingsMemento(settings)
  // caretaker.addMemento(memento)
  localStorage.setItem("settings", JSON.stringify(settings))
}
